import { useEffect, useState } from 'react'
import { Calendar, DateObject } from 'react-multi-date-picker'
import DatePanel from 'react-multi-date-picker/plugins/date_panel'
import { SickLeavePopUp } from '../ApplicationPopUps'
import { CustomerApplication } from '../../../utilities/CustomerData'

import infoIcon from '../../../assets/ApplicationIcons/infoIcon.png'
import estimateRefundIcon from '../../../assets/ApplicationIcons/estimateRefundIcon.png'

import '../../../css/CustomCalender.css'

export function ApplicationStep2({ _customerApplication, estimateRefund, handleBackToNetIncome, handleApplicationStep2, handleSetApplicationStep2 }) {
  const customerApplication = new CustomerApplication(_customerApplication)

  const [noTaxCreditGovJanuary, setNoTaxCreditGovJanuary] = useState(customerApplication.noTaxCreditGovJanuary)
  const [taxCreditGovJanuary, setTaxCreditGovJanuary] = useState(customerApplication.taxCreditGovJanuary)
  const [executedConversion, setExecutedConversion] = useState(customerApplication.executedConversion)

  const [showSickLeavePopup, setShowSickLeavePopup] = useState(false)
  const [showImportant, setShowImportant] = useState(false)

  useEffect(() => {
    handleSetApplicationStep2(taxCreditGovJanuary)
  }, [taxCreditGovJanuary])

  return (
    <div className='w-full flex justify-center'>
      <div className='w-11/12 h-full flex flex-col items-center lg:justify-center mt-6 mb-10 overflow-hidden'>
        {estimateRefund > 0 && (
          <div className='h-fit p-6 rounded-lg shadow-lg bg-gray-50 flex items-center gap-4 mb-4'>
            <div className='w-12 h-12 flex items-center justify-center rounded-full bg-secondaryColor object-contain'>
              <img 
                className='w-8 h-8' 
                src={estimateRefundIcon} 
                alt='Estimate Icon' 
              />
            </div>
            <div className='flex flex-col'>
              <p className='text-gray-600 text-sm font-medium'>Current Estimate</p>
              <p className='text-xl font-bold text-gray-900'>
                ${Number(estimateRefund).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </p>
            </div>
          </div>
        )}
        <p className='font-bold text-3xl text-setcb'>Sick Leave Tax Credit (You)</p>
        <p className='font-bold lg:text-2xl text-xl text-setcg mb-4'>$511 Daily Maximum Credit</p>
        <p className='mb-4'>Select the following dates you were impacted by COVID-19 causing you to be unable to work. <span onClick={() => setShowSickLeavePopup(true)} className='text-setcg cursor-pointer underline text-blue-600'>Not sure? Click here for more information</span></p>
        <div className='w-full gap-4'>
          <div className='mb-10'>
            <p className='font-bold mb-4'>Select up to 10 days between January 1, 2021, and March 31, 2021</p>
            <div className='flex flex-row max-sm:flex-col lg:items-center gap-4'>
              {!showSickLeavePopup && (
                <div className='w-full flex justify-center'>
                  <Calendar
                    className='custom-calendar'
                    value={taxCreditGovJanuary}
                    onChange={(e) => {
                      const newDates = e.map((date) => date.format())

                      if (newDates.length <= 10)
                        setTaxCreditGovJanuary(newDates)
                      else {
                        newDates.pop()
                        setTaxCreditGovJanuary(newDates)
                      }
                    }}
                    multiple
                    sort
                    format='YYYY-MM-DD'
                    minDate='2021-01-01'
                    maxDate='2021-03-31'
                    currentDate={new DateObject({
                      year: 2021,
                      month: 1,
                      day: 1
                    })}
                    plugins={[
                      <DatePanel />
                    ]}
                  >
                    <div className='w-full flex flex-col items-center'>
                      <p className='w-3/4 self-center text-xs italic'>Press any of the dates to select/deselect them</p>
                      <div className='w-full flex flex-row justify-center gap-4 self-center mt-4'>
                        <button onClick={() => setTaxCreditGovJanuary([])} className='rounded-md px-4 py-2 mb-4 bg-white hover:bg-gray-100'>
                          Clear
                        </button>
                      </div>
                    </div>
                  </Calendar>
                </div>
              )}
              <div className='w-full'>
                <div onClick={() => {
                  setTaxCreditGovJanuary([])
                  setNoTaxCreditGovJanuary(!noTaxCreditGovJanuary)

                  if (noTaxCreditGovJanuary)
                    setTaxCreditGovJanuary(customerApplication.taxCreditGovJanuary)
                }} className='flex flex-row items-center gap-2 mb-4 cursor-pointer'>
                  <input
                    type='checkbox'
                    checked={noTaxCreditGovJanuary}
                    onChange={(e) => {
                      setTaxCreditGovJanuary([])
                      setNoTaxCreditGovJanuary(e.target.checked)

                      if (!e.target.checked)
                        setTaxCreditGovJanuary(customerApplication.taxCreditGovJanuary)
                    }}
                  />
                  <p className='font-bold text-gray-500'>No Days</p>
                </div>
                <p className='text-gray-500'>You have selected <span className='font-bold'>{taxCreditGovJanuary.length} out of 10 days</span></p>
              </div>
            </div>
          </div>
        </div>
        <div className='w-full bg-[#0973ba] p-4 rounded-lg mb-4 text-white'>
          <div onClick={() => setShowImportant(!showImportant)} className='cursor-pointer flex flex-row items-center gap-2'>
            <img className='w-6' src={infoIcon} alt='Info Icon' />
            <p className='font-bold'>Important</p>
            <p className='ml-auto text-setcg'>{showImportant ? 'Collapse' : 'Expand'}</p>
          </div>
          {showImportant && (
            <div className='mt-4'>
              <p className='mb-6'>You are required to affirm in <span className='text-setcg font-bold'>GOOD FAITH</span> that you were unable to work due to COVID-19. No additional documentation is required when submitting your filing; however, please retain any records demonstrating days missed.</p>
              <p>Please note, any days claimed for unemployment benefits cannot be selected here.</p>
            </div>
          )}
        </div>
        <div className='flex flex-row items-center gap-4'>
          <button
            onClick={() => handleBackToNetIncome()}
            className='flex flex-row items-center gap-2 px-8 py-2 text-white rounded-md transition duration-200 mb-4 bg-gray-400 hover:bg-gray-500'
          >
            Back
          </button>
          <button
            disabled={(!noTaxCreditGovJanuary && taxCreditGovJanuary.length === 0)}
            onClick={() => handleApplicationStep2(noTaxCreditGovJanuary, taxCreditGovJanuary)}
            className={`flex flex-row items-center gap-2 px-8 py-2 text-white rounded-md transition-colors duration-200 mb-4 ${(!noTaxCreditGovJanuary && taxCreditGovJanuary.length === 0) ? 'bg-gray-400 cursor-not-allowed' : 'bg-primaryColor hover:bg-primaryDarkColor transition duration-200'}`}
          >
            Next
          </button>
        </div>
      </div>
      {showSickLeavePopup && (
        <SickLeavePopUp
          setShowSickLeavePopup={setShowSickLeavePopup}
        />
      )}
      {!executedConversion && (
         <iframe
          src='https://setcpros.com/pre-qualified-conversion-page/'
          style={{ width: 0, height: 0 }}
          title='Tracker'
        />
      )}
    </div>
  )
}

/**
 * <p>Are you filing single or married filing jointly?</p>
            <div className='flex flex-row items-center gap-4 mt-2'>
              <button onClick={() => setFilingStatus('Single')} className={`p-2 ${filingStatus === 'Single' ? 'bg-blue-500 hover:bg-blue-600 text-white' : 'hover:bg-blue-400 hover:text-white border-[1px] text-black'} rounded-md`}>
                Single Filing
              </button>
              <button onClick={() => setFilingStatus('MFJ')} className={`p-2 ${filingStatus === 'MFJ' ? 'bg-blue-500 hover:bg-blue-600 text-white' : 'hover:bg-blue-400 hover:text-white border-[1px] text-black'} rounded-md`}>
                Married Filing Jointly
              </button>
            </div>
 */